import { z } from 'zod'
import { lowerHexSchema } from '../../types/primitive'
import type { TransactionIndex } from '../../types/transactionIndex'
import type { EtherscanV2Client } from './client'

type GetListOfErc1155TokenTransferEventsByAddressParameters = {
  client: EtherscanV2Client
  address: string
  startblock?: number
  endblock?: number
  page?: number
  offset?: number
  sort?: 'asc' | 'desc'
  headers?: Record<string, string>
}

const transferSchema = z.object({
  blockNumber: z.string().regex(/^\d+$/).transform(Number),
  hash: lowerHexSchema,
  timeStamp: z.string().regex(/^\d+$/).transform(Number),
})
const resultSchema = z.array(transferSchema)

/** {@link https://docs.etherscan.io/etherscan-v2/api-endpoints/accounts#get-a-list-of-erc1155-token-transfer-events-by-address} */
export const getListOfErc1155TokenTransferEventsByAddress = async ({
  client,
  address,
  startblock = 0,
  endblock,
  page = 1,
  offset = 10_000,
  sort = 'asc',
  headers,
}: GetListOfErc1155TokenTransferEventsByAddressParameters): Promise<
  TransactionIndex[]
> => {
  try {
    const result = await client.get({
      path: '',
      query: {
        module: 'account',
        action: 'token1155tx',
        address,
        startblock: startblock.toString(),
        ...(endblock === undefined
          ? {}
          : {
              endblock: endblock.toString(),
            }),
        page: page.toString(),
        offset: offset.toString(),
        sort,
      },
      resultSchema,
      headers,
    })
    return result.map((v) => ({
      blockNumber: v.blockNumber,
      hash: v.hash,
      timestamp: v.timeStamp * 1000,
    }))
  } catch (error) {
    if (
      error instanceof Error &&
      (error.message === 'No transactions found' ||
        error.message === 'Error! Missing Or invalid Action name' ||
        error.message ===
          'Query Timeout occured. Please select a smaller result dataset')
    ) {
      return []
    }
    throw error
  }
}
